import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button } from '@whitelabel/component-library';
import { BOOKING_ID, SITE_NAME } from '@whitelabel/xcover-shared/helpers/constants';
import { ICustomer } from '../../helpers/types';
import { updateCustomerGDPR, updateBookingGDPR } from '../../actions';
import { RootState } from '../../store';
import { StyledConsentBanner, StyledConsentBannerBox } from './styled';
import messages from './messages';

interface IConsentBannerProp {
  customer?: ICustomer;
}

const ConsentBanner = ({ customer }: IConsentBannerProp) => {
  const intl = useIntl();
  const user = useSelector(({ user: { data } }: RootState) => data);
  const dispatch = useDispatch();

  return (
    <StyledConsentBannerBox>
      <StyledConsentBanner
        ButtonComponent={Button}
        disableStyles
        buttonText={intl.formatMessage(messages.acceptButtonText)}
        expires={365}
        onAccept={() => {
          const storedINS = localStorage.getItem(BOOKING_ID);
          if (user && customer) {
            dispatch(updateCustomerGDPR(customer.id));
          } else if (storedINS) {
            dispatch(updateBookingGDPR(storedINS));
          }
        }}
      >
        <FormattedMessage
          {...messages.bannerText}
          values={{
            siteName: SITE_NAME,
            link: <Link to={`/${intl.locale}/privacy-policy`}>{intl.formatMessage(messages.linkText)}</Link>,
          }}
        />
      </StyledConsentBanner>
    </StyledConsentBannerBox>
  );
};

export default ConsentBanner;
